var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.bodanList.length
    ? _c(
        "div",
        { staticClass: "bd-detail-list" },
        [
          _vm._l(_vm.bodanList, function (obj, index) {
            return _c(
              "div",
              { key: index, staticClass: "bd-detail-mod" },
              [
                _c("h2", [
                  _c("strong", [_vm._v(_vm._s(index + 1) + ".")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(obj.name))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bd-detail-mod-txt" }, [
                  _vm.getTxt(obj)
                    ? _c("span", [_vm._v(_vm._s(_vm.getTxt(obj)))])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                obj.width < obj.height
                  ? [
                      _c("div", { staticClass: "bd-img" }, [
                        _c("div", { staticClass: "bd-top-bg" }, [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: _vm.checkHttps(obj.picurl),
                                expression: "checkHttps(obj.picurl)",
                              },
                            ],
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "mask" }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "img-box" }, [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: _vm.checkHttps(obj.picurl),
                                expression: "checkHttps(obj.picurl)",
                              },
                            ],
                          }),
                        ]),
                      ]),
                    ]
                  : [
                      _c("div", { staticClass: "img-box-h" }, [
                        _c("img", { attrs: { src: obj.picurl } }),
                      ]),
                    ],
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      btn: obj.wholeplay !== "" && obj.quickplay !== "",
                    },
                  },
                  [
                    obj.quickplay !== ""
                      ? _c(
                          "a",
                          {
                            class: [{ more: obj.wholeplay === "" }, "quick"],
                            attrs: { href: obj.quickplay, uigs: "quick" },
                          },
                          [_vm._v("速看版")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    obj.wholeplay !== ""
                      ? _c(
                          "a",
                          {
                            class: [{ more: obj.quickplay === "" }, "whole"],
                            attrs: { href: obj.wholeplay, uigs: "whole" },
                          },
                          [_vm._v(_vm._s(obj.trailer ? "预告片" : "完整版"))]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                obj.wholeplay === "" && obj.quickplay === ""
                  ? _c(
                      "a",
                      {
                        staticClass: "more",
                        attrs: { id: "more", href: obj.moreplay, uigs: "more" },
                      },
                      [_vm._v("更多可播资源")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "intro" }, [
                  _vm._v("\n      " + _vm._s(obj.intro) + "\n    "),
                ]),
              ],
              2
            )
          }),
          _vm._v(" "),
          _c("span", { staticClass: "bd-detail-end" }, [_vm._v("- The End -")]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }